/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_MergeInputs */

const cs_enum_merge = /** @type {(inputs: Enum_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sloučení`)
};

const en_enum_merge = /** @type {(inputs: Enum_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge`)
};

/**
* | output |
* | --- |
* | "Merge" |
*
* @param {Enum_MergeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_merge = /** @type {((inputs?: Enum_MergeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_MergeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_merge(inputs)
	return cs_enum_merge(inputs)
});